import StudentsList from '../../../components/Student/StudentsList';

const Students = () => {
  return (
    <>
      <StudentsList />
    </>
  );
};
export default Students;
